export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + sizes[i];
};

export const fileSizeInMegaBytes = bytes => {
  return bytes / (1024 * 1024);
};

export const checkFileSizeLimit = (file, maximumUploadLimit) => {
  const fileSize = file?.file?.size || file?.size;
  const fileSizeInMB = fileSizeInMegaBytes(fileSize);
  return fileSizeInMB <= maximumUploadLimit;
};

export const calculateMediaDimensions = (width, height) => {
  if (!width || !height) return null;

  const aspectRatio = width / height;
  let calculatedWidth;
  let calculatedHeight;

  if (aspectRatio > 1) {
    // 横屏：固定宽度，计算高度
    calculatedWidth = 320;
    calculatedHeight = Math.round(320 / aspectRatio);
  } else {
    // 竖屏：固定高度，计算宽度
    calculatedHeight = 280;
    calculatedWidth = Math.round(280 * aspectRatio);
  }

  return {
    width: `${calculatedWidth}px`,
    height: `${calculatedHeight}px`,
    backgroundColor: '#f3f4f6',
    objectFit: 'cover',
    transition: 'all 0.2s ease-out',
  };
};
